module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "gv-panel-title gv-color-scheme"
  }, [_vm._c('span', {
    staticClass: "gv-color-scheme",
    attrs: {
      "title": _vm.fullTitle
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (!_vm.noClose) ? _vm._c('el-button', {
    staticClass: "gv-close gv-color-scheme",
    attrs: {
      "icon": "el-icon-close",
      "type": "button",
      "title": "Chiudi Panello"
    },
    on: {
      "click": _vm.closePanel
    }
  }) : _vm._e(), _vm._v(" "), (_vm.collapsible) ? _vm._c('button', {
    class: _vm.toggleCollapseClass(),
    attrs: {
      "size": "mini",
      "title": "Mostra/Nascondi Pannello"
    },
    on: {
      "click": _vm.collapse
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5056aadc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Title.vue
// module id = 858
// module chunks = 39